import { Component } from '@angular/core';

@Component({
  styles: [ require('./public.component.scss') ],
  template: require('./public.component.html')
})
export class PublicComponent {}
